var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2.16211C5.13438 2.16211 2 5.29648 2 9.16211C2 13.0277 5.13438 16.1621 9 16.1621C12.8656 16.1621 16 13.0277 16 9.16211C16 5.29648 12.8656 2.16211 9 2.16211ZM8.5 5.78711C8.5 5.71836 8.55625 5.66211 8.625 5.66211H9.375C9.44375 5.66211 9.5 5.71836 9.5 5.78711V10.0371C9.5 10.1059 9.44375 10.1621 9.375 10.1621H8.625C8.55625 10.1621 8.5 10.1059 8.5 10.0371V5.78711ZM9 12.6621C8.80374 12.6581 8.61687 12.5773 8.47948 12.4371C8.3421 12.2969 8.26515 12.1084 8.26515 11.9121C8.26515 11.7158 8.3421 11.5273 8.47948 11.3871C8.61687 11.2469 8.80374 11.1661 9 11.1621C9.19626 11.1661 9.38313 11.2469 9.52052 11.3871C9.6579 11.5273 9.73485 11.7158 9.73485 11.9121C9.73485 12.1084 9.6579 12.2969 9.52052 12.4371C9.38313 12.5773 9.19626 12.6581 9 12.6621Z",
    fill: "#FAAD14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.fbd021fcf4ddcb5a5f0a976915c701ae.svg";
export { ForwardRef as ReactComponent };